/**
 * 生成二维码接口
 */

export default {
    createQrCode: `${process.env.VUE_APP_API_URL}/v1/user/wechat/create_file`,
};
